import React from "react";
import { ArrowRight } from "lucide-react";
import { useStartFlow } from "@/lib/useStart";

export const StickyMobileCTA = () => {
  const start = useStartFlow();
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-40 p-3 bg-background/90 backdrop-blur-xl border-t border-border" data-testid="sticky-mobile-cta">
      <button
        onClick={() => start("sticky-mobile")}
        className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-amber-400 to-red-600 text-white font-medium py-3.5"
      >
        Start sarkarijobai <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  );
};
